<template>
  <div>
    <topnav
       
      class="w-100"
      style="position: fixed; z-index: 999; top: 0;"
    ></topnav>
    <router-view></router-view>
    <footr-secondary v-if="this.$route.name == 'Category' || this.$route.name == 'Detail'  && this.$router.name != 'sale' && this.$route.name != 'telemedicina-diabetes' "/>
    <footr v-else />
  </div>
</template>
<script>
import { mapState } from "vuex";
import topnav from "./../layouts/nav_bar.vue";
import footr from "./../layouts/footer.vue";
import footrSecondary from "./../layouts/footerSecondary.vue";
export default {
  name: "",
  components: {
     topnav,
    footr,
    footrSecondary
    // topNavIfLogin,
  },
  created() {},
  data() {
    return {
      navBar: localStorage.getItem("isLogIn"),
    };
  },
  computed: {
    ...mapState,
  },
  methods: {},
};
</script>
